import {
  Box,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Divider,
} from "@mui/material";

function TicketsSkeletons() {
  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h4" fontWeight={600} marginBottom={2} marginTop={1}>
        <Skeleton width={220} height={40} />
      </Typography>
      <Divider sx={{ my: 2 }} />
      <Box
        display="flex"
        alignItems="flex-end"
        mb={2}
        flexWrap="wrap"
        justifyContent="space-between"
        gap={2}
      >
        <Box minWidth={250}>
          <Skeleton variant="rectangular" height={40} width="100%" />
        </Box>
        <Box display="flex" alignItems="flex-end" gap={4}>
          <Skeleton variant="rectangular" height={40} width={120} />
          <Skeleton variant="rectangular" height={40} width={160} />
        </Box>
      </Box>
      <TableContainer sx={{ overflowX: "auto" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ whiteSpace: "nowrap" }}>
                <Skeleton width={80} height={24} />
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>
                <Skeleton width={120} height={24} />
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>
                <Skeleton width={140} height={24} />
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>
                <Skeleton width={120} height={24} />
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>
                <Skeleton width={80} height={24} />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {[...Array(6)].map((_, idx) => (
              <TableRow key={idx}>
                <TableCell>
                  <Skeleton width={80} height={24} />
                </TableCell>
                <TableCell>
                  <Skeleton width={120} height={24} />
                </TableCell>
                <TableCell>
                  <Skeleton width={140} height={24} />
                </TableCell>
                <TableCell>
                  <Skeleton width={120} height={24} />
                </TableCell>
                <TableCell>
                  <Skeleton width={80} height={32} variant="rounded" />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

export default TicketsSkeletons;
